"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgBadge = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.926 6.597a1.016 1.016 0 0 0-1.852 0l-.676 1.422-1.513.228c-.847.128-1.185 1.208-.572 1.828l1.094 1.107-.258 1.563c-.145.875.74 1.543 1.498 1.13L12 13.136l1.353.737c.757.414 1.643-.254 1.498-1.13l-.258-1.562 1.094-1.107c.613-.62.275-1.7-.572-1.828l-1.513-.228-.676-1.422Zm-1.29 2.342L12 8.172l.365.767c.15.316.44.535.777.586l.816.123-.59.597c-.244.246-.355.6-.298.948l.14.843-.73-.398a1 1 0 0 0-.96 0l-.73.398.14-.843a1.097 1.097 0 0 0-.297-.948l-.59-.597.815-.123c.336-.05.627-.27.777-.586Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 16.245a8 8 0 1 1 10 0V21a1 1 0 0 1-1.351.936L12 20.568l-3.649 1.368A1 1 0 0 1 7 21v-4.755ZM6 10c0 1.577.608 3.011 1.603 4.082A5.984 5.984 0 0 0 12 16a5.984 5.984 0 0 0 4.397-1.918A6 6 0 1 0 6 10Zm9 7.419A7.978 7.978 0 0 1 12 18a7.978 7.978 0 0 1-3-.581v2.138l2.649-.993a1 1 0 0 1 .702 0l2.649.993v-2.138Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgBadge);
//# sourceMappingURL=SvgBadge.js.map